import { Injectable } from "@angular/core";
import { isDefined, isUndefined } from "./data-util";
import { NgEventBus } from "ng-event-bus";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "./app-config.service";
import { tap } from "rxjs";
import {Permission} from "../models/permission.model";

@Injectable({
    providedIn: 'root'
})
export class AuthenticatorService {
    title = 'Authenticator Service';

    constructor(
        private eventBus: NgEventBus,
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {
    }

    checkLogin() {
    }

    logout() {
        console.debug(this.title + ' logout');
        window.localStorage.removeItem('jwtToken');
        window.sessionStorage.clear();
        this.http.get(this.appConfigService.settings.pingFederateLogout).subscribe({
            next: () => {
                console.debug("Logged out");
                window.location.href = '/';
            },
            error: error => {
                console.error("Not logged out properly...");
                window.location.href = this.appConfigService.settings.pingFederateLogout; //'/' or + '?TargetResource=' + redirectPingIdentity;
            }
        });
    }

    getLocalStorageToken() {
        return window.localStorage['jwtToken']
    }

    getToken() {
        const localStorageToken = window.localStorage['jwtToken'];
        if (isUndefined(localStorageToken)) {
            return {};
        }
        const base64Url = localStorageToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        const token = JSON.parse(window.atob(base64));
        return token;
    }


    isTokenExpired(token) {
        const currentTime = Math.floor(Date.now() / 1000);
        const expirationTime = token.exp;
        return expirationTime < currentTime;
    }

    getUsername() {
        return this.getToken().sub;
    }

    getDisplayName() {
        //$log.debug(this.title + ' getDisplayName');
        const token = this.getToken();
        return token.givenName + ' ' + token.surname;
    }

    getUsersFirmNumber(): number {
        return this.getToken().firmNumber;
    }

    redirectToPF() {
        const url = this.appConfigService.settings.pingFederateUrl + this.appConfigService.settings.pingFederateParameters + this.appConfigService.settings.redirectPingIdentity;
        console.log(url);
        window.location.href = url;
    };

    login(username, password, callback) {
    }

    isLoggedIn() {
        return this.http.get(this.appConfigService.settings.apiGatewayUrl + "/auth/isLoggedIn")
            .pipe(
                tap({
                    next: recieved => {
                        console.log("Logged in");
                        const data: any = recieved;
                        if (isUndefined(data)) {
                            window.localStorage.removeItem("jwtToken");
                            this.redirectToPF();
                        } else if (window.localStorage["jwtToken"]) {
                        } else {
                            window.location.href = "/#/home";
                        }
                    },
                    error: error => {
                        console.error("Not logged in... Redirecting to AUTH");
                        this.redirectToPF();
                    },
                    complete: () => {
                    }
                }));
    }
}
